// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2ZcQi","emails":"CreateEditClinics_emails__2oyJz","emailTagLabel":"CreateEditClinics_emailTagLabel__yOLkJ"};